import styled from 'styled-components';

export const PageShell = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

export const MainContent = styled.main`
  flex: 1;
  padding-top: ${({ theme }) => `calc(${theme.layout.headerHeightMobile} + ${theme.spacing.xl})`};

  ${({ theme }) => theme.media.md} {
    padding-top: ${({ theme }) => `calc(${theme.layout.headerHeight} + ${theme.spacing.xl})`};
  }
`;

export const SiteContainer = styled.div`
  width: 100%;
  max-width: ${({ $maxWidth, theme }) => $maxWidth || theme.container.maxWidth};
  margin: 0 auto;
  padding-inline: ${({ $compact }) => ($compact ? '0' : '1rem')};

  ${({ theme }) => theme.media.md} {
    padding-inline: ${({ $compact }) => ($compact ? '0' : '1.5rem')};
  }
`;

export const Section = styled.section`
  padding-block: ${({ $dense, theme }) => ($dense ? theme.spacing['2xl'] : theme.spacing['3xl'])};

  ${({ theme }) => theme.media.md} {
    padding-block: ${({ $dense, theme }) => ($dense ? theme.spacing['3xl'] : theme.spacing['4xl'])};
  }
`;

export const SectionIntro = styled.div`
  max-width: ${({ theme }) => theme.container.narrow};
  margin: 0 auto ${({ theme }) => theme.spacing['2xl']};
  text-align: center;
`;

export const Eyebrow = styled.p`
  margin-bottom: ${({ theme }) => theme.spacing.sm};
  color: ${({ theme }) => theme.colors.accentStrong};
  font-size: ${({ theme }) => theme.fontSizes.label};
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
`;

export const DisplayTitle = styled.h1`
  font-family: ${({ theme }) => theme.fonts.display};
  font-size: ${({ $hero, theme }) => ($hero ? theme.fontSizes.hero : theme.fontSizes.h1)};
  line-height: ${({ theme }) => theme.lineHeights.tight};
  letter-spacing: -0.02em;
`;

export const SectionTitle = styled.h2`
  font-family: ${({ theme }) => theme.fonts.display};
  font-size: ${({ theme }) => theme.fontSizes.h2};
  line-height: ${({ theme }) => theme.lineHeights.heading};
  letter-spacing: -0.02em;
  margin-bottom: ${({ theme }) => theme.spacing.md};
`;

export const Lead = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.bodyLg};
  color: ${({ theme }) => theme.colors.textMuted};
  max-width: 65ch;
  margin-inline: auto;
`;

export const BodyText = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.body};
  color: ${({ theme }) => theme.colors.textMuted};
  max-width: ${({ $measure }) => $measure || '68ch'};
`;

export const SurfaceCard = styled.div`
  background: ${({ theme }) => theme.colors.surface};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radii.lg};
  box-shadow: ${({ theme }) => theme.shadows.sm};
`;
